/*
 * @Author: lyy 2896768658@qq.com
 * @Date: 2023-10-16 10:48:53
 * @LastEditors: lyy 2896768658@qq.com
 * @LastEditTime: 2023-10-17 19:23:01
 * @FilePath: \zljt-bigdata-web\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/newViews/Login'
// import FirstPage from '@/views/firstPage/FirstPage2'
import home from './home.js'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'firstPage',
      // component: FirstPage,
      component: Login,
    },
    {
      path: '/homepage',
      name: 'transitionalPage',
      component: () => import("@/components/transitionalPage")
    },
    ...home,
    {//没权限
      path: "/no-permission",
      name: "no-permission",
      component: () => import("@/components/no_permission.vue")
    },
    {// 404
      path: "*",
      name: "all-404",
      component: () => import("@/components/404.vue")
    },
  ]
})

const routerPush = Router.prototype.push;

Router.prototype.push = function push (location, onResolve, onReject) {

  if (onResolve || onReject) return routerPush.call(this, location, onResolve, onReject);
  return routerPush.call(this, location).catch(error => error)

};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js